import React from "react";

const HighScoresTable = ({ rows = [] }) => {
  if (!rows || rows.length === 0) return null;

  return (
    <div className="endgame-table highscores-table">
      <div className="endgame-table-header">
        <div>🏆 Place</div>
        <div>💎 Net Worth</div>
        <div>👤 Player</div>
        <div>💰 Cash</div>
        <div>💵 Biggest Sell</div>
        <div>📈 Biggest Gain</div>
        <div>👥 Players</div>
        <div>🔄 Rounds</div>
      </div>
      <div className="endgame-table-body">
        {rows.map((row, index) => (
          <div key={`${row.position}-${row.name}-${index}`} className="endgame-table-row">
            <div className="endgame-place">
              {row.position}
            </div>
            <div className="endgame-networth">
              ${row.netWorth ?? 0}
            </div>
            <div className="endgame-player">
              <div
                className="endgame-avatar"
                style={{ backgroundColor: row.color || "var(--color-gray-200)" }}
              >
                {row.emoji || "🙂"}
              </div>
              <span className="endgame-name">{row.name}</span>
            </div>
            <div className="endgame-cash">
              ${row.cash ?? 0}
            </div>
            <div className="endgame-stat">
              ${row.biggestSell ?? 0}
            </div>
            <div className="endgame-stat">
              ${row.biggestGain ?? 0}
            </div>
            <div className="endgame-stat">
              {row.numPlayers ?? 0}
            </div>
            <div className="endgame-stat">
              {row.numRounds ?? 0}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HighScoresTable;

